import request from '.././http';
// 更新updatePass
export const updatePass = (data) => {
  return request({
    url: '/myAccount/updatePass',
    method: 'post',
    data: data,
  });
};
// 更新updateAccountDetail
export const updateAccountDetail = (data) => {
  return request({
    url: '/myAccount/updateAccountDetail',
    method: 'post',
    data: data,
  });
};
// 更新userInfo
export const updateUserInfo = (data) => {
  return request({
    url: '/myAccount/userInfo',
    method: 'post',
    data: data,
  });
};
// 更新Tax
export const addOrUpdateTax = (data) => {
  return request({
    url: '/myAccount/tax/addOrUpdate',
    method: 'post',
    data: data,
  });
};
export function policy(data) {
  return request({
    url: '/rm/cms/feil/uploadMonofile',
    method: 'post',
    data: data,
  });
}
// 地址列表
export const addressList = (data) => {
  return request({
    url: '/myAccount/address/list',
    method: 'post',
    data: data,
  });
};
// addressAdd
export const addressAdd = (data) => {
  return request({
    url: '/myAccount/address/add',
    method: 'post',
    data: data,
  });
};
// addressDefault
export const addressDefault = (data) => {
  return request({
    url: '/myAccount/address/default',
    method: 'post',
    data: data,
  });
};
// addressDelete
export const addressDelete = (data) => {
  return request({
    url: '/myAccount/address/delete',
    method: 'post',
    data: data,
  });
};
// addressDetail
export const addressDetail = (data) => {
  return request({
    url: '/myAccount/address/detail',
    method: 'post',
    data: data,
  });
};
// addressUpdate
export const addressUpdate = (data) => {
  return request({
    url: '/myAccount/address/update',
    method: 'post',
    data: data,
  });
};
// queryDefaultAddress 支付界面默认展示的地址
export const queryDefaultAddress = (data) => {
  return request({
    url: '/myAccount/queryDefaultAddress',
    method: 'post',
    data: data,
  });
};
// orderList
export const orderList = (data) => {
  return request({
    url: '/order/list',
    method: 'post',
    data: data,
  });
};
// deleteList
export const deleteList = (data) => {
  return request({
    url: '/order/deleteList',
    method: 'post',
    data: data,
  });
};
// orderDetail
export const orderDetail = (data) => {
  return request({
    url: '/order/detail',
    method: 'post',
    data: data,
  });
};
// queryProductPrice  查询支付界面的商品价格信息
export const queryProductPrice = (data) => {
  return request({
    url: '/order/queryProductPrice',
    method: 'post',
    data: data,
  });
};
// submitOrder  购物车界面提交商品价格信息
export const submitOrder = (data) => {
  return request({
    url: '/order/submit',
    method: 'post',
    data: data,
  });
};
// 售后保存
export const salesOrderSave = (data) => {
  return request({
    url: '/salesOrder/save',
    method: 'post',
    data: data,
  });
};
// 收藏 列表queryList
export const savedQueryList = (data) => {
  return request({
    url: '/saved/queryList',
    method: 'post',
    data: data,
  });
};
// 收藏 remove
export const savedRemove = (data) => {
  return request({
    url: '/saved/remove',
    method: 'post',
    data: data,
  });
};
// 收藏 moveToCart
export const savedMoveToCart = (data) => {
  return request({
    url: '/saved/moveToCart',
    method: 'post',
    data: data,
  });
};
// 收藏 deleteList
export const savedDeleteList = (data) => {
  return request({
    url: '/saved/deleteList',
    method: 'post',
    data: data,
  });
};
// 添加收藏 createList
export const savedCreateList = (data) => {
  return request({
    url: '/saved/createList',
    method: 'post',
    data: data,
  });
};
